import * as Communication from "../communication";
import MyStream from "./MyStream.vue";
export default {
    name: "joinPrompt",
    components: {
        MyStream: MyStream,
    },
    data: function () {
        return {
            name: "",
        };
    },
    computed: {
        isButtonDisabled: function () {
            return !this.name || !this.$store.getters.localStream;
        },
    },
    watch: {
        locale: function (val) {
            this.$i18n.locale = val;
        },
    },
    methods: {
        onInput: function () {
            var defaultName = this.$store.getters.defaultLocalUserName;
            this.$store.dispatch("updateLocalUserName", this.name || defaultName);
        },
        onSubmit: function () {
            var _this = this;
            this.$store.dispatch("updateAppState", "joining");
            this.$socket.on("joinPeerResponse", function (payload) {
                if (payload.result !== "OK") {
                    _this.$store.dispatch("setFatalError", payload.result);
                    return;
                }
                _this.$store.dispatch("setFatalError", undefined);
            });
            Communication.establish(this.$socket, this.$store);
            this.$socket.open(this.name);
        },
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/JoinPrompt.vue
// module id = 327
// module chunks = 1